export default __webpack_public_path__ + "static/media/travily.884cd173.PNG";